import Api from "@/services/api.js";

// state
const state = () => ({
  empresa: {
    id: null,
    name: "Selecione uma empresa",
    cnpj: "",
    id_regime_tributario: "",
    id_uf: ""
  },
  listEmpresa: []
});

// getters
const getters = {
  getEmpresa: state => {
    return state.empresa;
  },
  getListEmpresa: state => {
    return state.listEmpresa;
  }
};

// mutations
const mutations = {
  SET_EMPRESA(state, empresa) {
    state.empresa = empresa;
  },
  SET_LIST_EMPRESA(state, listEmpresa) {
    state.listEmpresa = listEmpresa;
  }
};

// actions
const actions = {
  setEmpresa({ commit }, empresa) {
    commit("SET_EMPRESA", empresa);
  },
  resetEmpresa({ commit }) {
    const empresa = {
      id: null,
      name: "Selecione uma empresa",
      cnpj: "",
      id_regime_tributario: "",
      id_uf: ""
    };

    commit("SET_EMPRESA", empresa);
  },
  setListEmpresa({ commit }, listEmpresa) {
    commit("SET_LIST_EMPRESA", listEmpresa);
  },
  async fetchEmpresas({ commit, state }, idUsuario) {
    if (state.listEmpresa.length > 0) {
      return;
    }

    let listEmpresa = [];
    const response = await new Api().get("Empresa/obterEmpresas/" + idUsuario);

    await response.dados.map((emp, index) => {
      listEmpresa.push({
        id: emp.id,
        nome: emp.nome,
        cnpj: emp.cnpj,
        id_regime_tributario: emp.id_regime_tributario ? emp.id_regime_tributario : "",
        id_uf: emp.id_uf ? emp.id_uf : "",
        empresa_cnae: emp.empresa_cnae
      });

      // if (index == 0)
      //   that.empresaBase = emp;
    });

    commit("SET_LIST_EMPRESA", listEmpresa);
  },
  async fetchListaEmpresas(context) {
    const usuario = context.rootGetters["login/getUser"];
    const response = await new Api().get(`Empresa/obterEmpresas/${btoa(usuario.id_usuario)}`);
    context.commit("SET_LIST_EMPRESA", response.dados);
  },
  async forceFetchEmpresas({ commit }, idUsuario) {
    let listEmpresa = [];
    const response = await new Api().get("Empresa/obterEmpresas/" + idUsuario);

    await response.dados.map((emp, index) => {
      listEmpresa.push({
        id: emp.id,
        nome: emp.nome,
        cnpj: emp.cnpj,
        id_regime_tributario: emp.id_regime_tributario ? emp.id_regime_tributario : "",
        id_uf: emp.id_uf ? emp.id_uf : "",
        empresa_cnae: emp.empresa_cnae
      });
    });

    commit("SET_LIST_EMPRESA", listEmpresa);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
